import { IFilterPureDescriptor, IJsonQuery } from '../../types/interfaces';
import { isDescriptorActive } from './isDescriptorActive';

export function isValid(state: IJsonQuery) {
  return (descriptor: IFilterPureDescriptor) =>
    descriptor.when
      ? descriptor.when.some((d) => isDescriptorActive({form: [d]})(state))
      : true;
}
